module.exports = __webpack_public_path__ + "img/user-01.6f3fd73c.svg";